import styled from '@emotion/styled';

import Grid from '@mui/material/Grid';

const StyledPatientRegionDetails = styled(Grid)`
  display: flex;
  flex-wrap: wrap;

  .recovery-plan-button {
     background-color: #FAFAFA;
     color: #161728;

     &.Mui-selected,:active,:hover {
      background-color: black;
      color: white;
    }
  }
`;

export default StyledPatientRegionDetails;
